export default {
	props: {
		title: String,
		room_id: Number,
		rate_id: Number,
		max_room_qty: Number,
		max_adults: Number,
		children_on_bed: { type:Object, default:()=>({max_qty:0,from_age:null,to_age:null}) },
		children_no_bed: { type:Object, default:()=>({max_qty:0,from_age:null,to_age:null}) },
		num_nights: Number,
		currency: String,
		precision: {type:Number, default: 0},
		value:{ type:Object, default:()=>({}) },
	},
	data(){
		return {
			loading:false,
			innerValue: null,
			numAdults: 1,
			childrenByAgesOnBed: [],
			childrenByAgesNoBed: [],
			onChangeGuestsDebounce: getDebounceFunc(this.onChangeGuests),

			childOnBedSettings: this.children_on_bed,
			childNoBedSettings: this.children_no_bed,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(val){
				this.innerValue = this.value ? this.value : {};

				//1
				let tmp1 = typeof(this.innerValue.numAdults)!=='undefined'&&this.innerValue.numAdults!==null ? this.innerValue.numAdults : 1;
				if(this.numAdults!==tmp1){
					this.numAdults = tmp1;
				}
				//2
				let tmp2 = this.innerValue.childrenByAgesOnBed ? this.innerValue.childrenByAgesOnBed : [];
				if(this.childrenByAgesOnBed.join()!==tmp2.join()){
					this.childrenByAgesOnBed = tmp2;
				}
				//3
				let tmp3 = this.innerValue.childrenByAgesNoBed ? this.innerValue.childrenByAgesNoBed : [];
				if(this.childrenByAgesNoBed.join()!==tmp3.join()){
					this.childrenByAgesNoBed = tmp3;
				}
			},
		},
		numAdults:{
			immediate: true,
			handler(val){
				this.loading = true;
				this.onChangeGuestsDebounce();
			},
		},
		childrenByAgesOnBed:{
			immediate: true,
			handler(val){
				this.loading = true;
				this.onChangeGuestsDebounce();
			},
		},
		childrenByAgesNoBed:{
			immediate: true,
			handler(val){
				this.loading = true;
				this.onChangeGuestsDebounce();
			},
		},
		childOnBedSettings(val){
			let deleteQty = this.childrenByAgesOnBed.length - val.max_qty;
			if(deleteQty>0){
				this.childrenByAgesOnBed.splice(val.max_qty, deleteQty);
			}
		},
		childNoBedSettings(val){
			let deleteQty = this.childrenByAgesNoBed.length-val.max_qty;
			if(deleteQty>0){
				this.childrenByAgesNoBed.splice(val.max_qty, deleteQty);
			}
		},
	},

	computed:{
		cp_adultsOptions(){
			let options = [];
			for(let i=1;i<=this.max_adults;i++){
				options.push({label:this.$tc('numAdults', i), value: i});
			}
			return options;
		},

		//on bed
		cp_childrenOnBedMaxQty(){
			return this.childOnBedSettings.max_qty;
		},
		cp_childrenOnBedAgeRange(){
			return `${this.childOnBedSettings.from_age}-${this.childOnBedSettings.to_age}`;
		},
		cp_childrenOnBedOptions(){
			return this.getChildrenOptions(this.childOnBedSettings.from_age, this.childOnBedSettings.to_age);
		},
		//

		//no bed
		cp_childrenNoBedMaxQty(){
			return this.childNoBedSettings.max_qty;
		},
		cp_childrenNoBedAgeRange(){
			return `${this.childNoBedSettings.from_age}-${this.childNoBedSettings.to_age}`;
		},
		cp_childrenNoBedOptions(){
			return this.getChildrenOptions(this.childNoBedSettings.from_age, this.childNoBedSettings.to_age);
		},

		//guests
		cp_guests(){
			if(!this.innerValue || !this.innerValue.available) return null;

			let result  = [];
			for(const i in this.innerValue.acm_items){
				const acmQty = parseInt(this.innerValue.acm_items[i].acm_qty);
				for(const j in this.innerValue.acm_items[i].acm_subitems){
					const el = this.innerValue.acm_items[i].acm_subitems[j];
					result.push({bed_code:el.bed_code, person_code:el.person_code, person_qty:parseInt(el.person_qty)*acmQty, from_age:el.from_age, to_age:el.to_age});
				}
			}

			return result;
		}
	},

	methods: {
		getChildrenOptions(age_from, age_to){
			let options = [];
			for(let i=age_from;i<=age_to;i++){
				options.push({label:this.$tc('childrenAge', i), value: i});
			}
			return options;
		},
		//on bed
		onAddChild(isOnBed, val){
			let defValue = -1;
			if(val<=defValue) return;

			if(isOnBed){
				this.$set(this.childrenByAgesOnBed, this.childrenByAgesOnBed.length, val);
				this.$refs.lastChildOnBed.setInnerValue(defValue);
			}
			else {
				this.$set(this.childrenByAgesNoBed, this.childrenByAgesNoBed.length, val);
				this.$refs.lastChildNoBed.setInnerValue(defValue);
			}
		},
		onDeleteChild(isOnBed, i){
			if(isOnBed){
				this.childrenByAgesOnBed.splice(i, 1);
			} else {
				this.childrenByAgesNoBed.splice(i, 1);
			}
		},

		onChangeGuests(){
			let childrenByAgesOnBed = this.childrenByAgesOnBed.filter(v=>v>-1);
			let childrenByAgesNoBed = this.childrenByAgesNoBed.filter(v=>v>-1);

			this.$root.getPriceForGuests(this.room_id, this.rate_id, this.numAdults, childrenByAgesOnBed, childrenByAgesNoBed)
				.then((response)=>{
					if(!response) throw new Error('Empty response!!!');

					if(response.settings){
						if(response.settings.children_on_bed){
							this.childOnBedSettings = response.settings.children_on_bed;
						}
						if(response.settings.children_no_bed){
							this.childNoBedSettings = response.settings.children_no_bed;
						}
					}

					let data = {...response.data, selected_qty:1};
					if(response.data.available){
						this.$emit('input', data);
					} else {
						this.innerValue = data;
					}
				})
				.catch((e)=>{
					alert(e);
				})
				.finally(()=>{
					//finally
					this.loading = false;
				});
		},
	},
	template: `
<div class="manual-select-room-guests">

	<div class="title">
		<span>{{title}}</span>
		<span class="qicon-1 clear-icon active" @click="$emit('delete')">trash</span>
	</div>

  <div class="hr"></div>

	<div class="row__separator">
		<div class="col1">
			{{$t('selectNumAdults')}}
		</div>
		<div class="col2">
			<qit-select class="v3" :options="cp_adultsOptions" v-model="numAdults"/>
		</div>
	</div>

  <div class="hr"></div>
	
	<div class="row__separator" v-if="cp_childrenOnBedMaxQty>0">
		<div class="col1">
			{{$t('addChildrenOnBed')}}<br /><span class="small-text">(max: {{cp_childrenOnBedMaxQty}}, age:{{cp_childrenOnBedAgeRange}})</span>
		</div>
		<div class="col2">
			<qit-select
				v-for="(val,i) in Math.min(childrenByAgesOnBed.length, cp_childrenOnBedMaxQty)" :key="i"
				class="v3"
				:label="$t('addChild')" :label-value="-1" label-disabled
				:options="cp_childrenOnBedOptions"
				v-model="childrenByAgesOnBed[i]"
				clearable
				@clear="onDeleteChild(true, i)"
			/>
			<qit-select
				v-if="childrenByAgesOnBed.length<cp_childrenOnBedMaxQty"
				ref="lastChildOnBed"
				class="v3"
				:label="$t('addChild')" :label-value="-1" label-disabled
				:options="cp_childrenOnBedOptions"
				clearable
				@input="onAddChild(true, $event)"
			/>
		</div>
	</div>

  <div class="hr"></div>

	<div class="row__separator" v-if="cp_childrenNoBedMaxQty>0">
		<div class="col1">
			{{$t('addChildrenNoBed')}}<br /><span class="small-text">(max: {{cp_childrenNoBedMaxQty}}, age:{{cp_childrenNoBedAgeRange}})</span>
		</div>
		<div class="col2">
			<qit-select
				v-for="(val,i) in Math.min(childrenByAgesNoBed.length, cp_childrenNoBedMaxQty)" :key="i"
				class="v3"
				:label="$t('addChild')" :label-value="-1" label-disabled
				:options="cp_childrenNoBedOptions"
				v-model="childrenByAgesNoBed[i]"
				clearable
				@clear="onDeleteChild(false,i)"
			/>
			<qit-select
				v-if="childrenByAgesNoBed.length<cp_childrenNoBedMaxQty"
				ref="lastChildNoBed"
				class="v3"
				:label="$t('addChild')" :label-value="-1" label-disabled
				:options="cp_childrenNoBedOptions"
				clearable
				@input="onAddChild(false,$event)"
			/>
		</div>
	</div>

  <div class="hr"></div>

	<div class="row__separator">
		<template v-if="innerValue.available">
			<div class="msrg-result">

        <div class="title mid-title"><qit-guests-icons :guests="cp_guests"></qit-guests-icons></div>

				<div class="price__holder">
					<div v-if="innerValue.old_price" class="old-price-and-discount">
            <span class="price discount" v-html="formatAmount(innerValue.old_price, currency, precision, true, $i18n.locale)"></span>
            <span class="percent">{{ -1 * innerValue.discount_percent }}%</span>
					</div>
					<span class="price" v-html="formatAmount(innerValue.price, currency, precision, true, $i18n.locale)"></span>
          <span class="price__lbl" v-text="$tc('forNumNights', num_nights)"></span>
				</div>

				<a class="link info" @click="$refs.modalDialog.show()"></a>

        <qit-modal-dialog ref="modalDialog">
          <div class="modal__row"><div class="title">{{ $t('priceDetails') }}</div></div>

          <div class="hr"></div>

          <div class="modal__row">
            <div class="row__separator row__separator-va-center" v-for="(item,i) in innerValue.acm_items" :key="i">
              <div v-for="(el,j) in item.acm_subitems" :key="j">
                {{$tc(el.person_code === 'A' ? 'numAdults':'numChildren', parseInt(el.person_qty) * parseInt(item.acm_qty))}}
                {{el.from_age != null && el.to_age != null?$t('onAgeRange', {from_age: el.from_age, to_age: el.to_age}):''}}
                {{el.bed_code ? $t('onBed' + el.bed_code):''}}
              </div>
              <div class="price__holder">
                <div class="price" v-html="formatAmount(item.price, currency, precision, true, $i18n.locale)"></div>
              </div>
            </div>
            <div class="row__separator" v-if="innerValue.es_insp_price>0">
              <div>{{ $t('extraServices.additionalServicesIncluded') }}</div>
              <div class="price__holder"><div class="price"></div></div>
            </div>
          </div>
        </qit-modal-dialog>
			</div>
		</template>
		<template v-else>
			<qit-restrictions-reasons class="msrg-reasons" :reasons="innerValue.reasons"></qit-restrictions-reasons>
		</template>
	</div>

	<div class="loading-overlay" v-if="loading"><span class="loading-icon"></span></div>
</div>
`,
}
